import React from 'react'
import { Interval, EhrAppointmentSchedulingRuleDef, Subscription } from '@src/types'
import { isTrial } from '../../utils/utils'
import { Fields, ProductSummaryFields } from './ProductSummaryFields'

interface SubscriptionFieldsProps {
  subscription: Pick<
    Subscription,
    | 'id'
    | 'price'
    | 'discountedPrice'
    | 'currentPeriodEndAt'
    | 'commitmentEndAt'
    | 'cancelAt'
    | 'resumesAt'
    | 'resetBillingCycleAnchorAt'
    | 'status'
    | 'paused'
  > & {
    primaryProduct: {
      ehrSchedulingRule: Pick<EhrAppointmentSchedulingRuleDef, 'count'>
      interval: Pick<Interval, 'suffix'>
    }
  }
  mode: 'full' | 'compact'
  fields: Fields[]
}

export const SubscriptionFields = ({
  subscription,
  mode = 'full',
  fields,
}: SubscriptionFieldsProps) => {
  return (
    <ProductSummaryFields
      product={subscription.primaryProduct}
      price={subscription.discountedPrice}
      currentPeriodEndAt={subscription.currentPeriodEndAt}
      commitmentEndAt={subscription.commitmentEndAt}
      cancelAt={subscription.cancelAt}
      resumesAt={subscription.resumesAt}
      resetBillingCycleAnchorAt={subscription.resetBillingCycleAnchorAt}
      isTrial={isTrial(subscription)}
      mode={mode}
      fields={fields}
      subscription={subscription}
    />
  )
}
